import { AlertBadge } from './AlertBadge'

interface Alert {
  id: string
  alert_type: string
  severity: string
  title: string
  description?: string
  created_at: string
}

interface AlertPanelProps {
  alerts: Alert[]
  onResolve?: (id: string) => void
}

export function AlertPanel({ alerts, onResolve }: AlertPanelProps) {
  if (alerts.length === 0) {
    return (
      <div
        style={{
          padding: '24px',
          textAlign: 'center',
          color: 'var(--ink-muted)',
          fontFamily: 'var(--sans)',
          fontSize: '14px',
        }}
      >
        Sem alertas activos
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      {alerts.map((alert) => (
        <div
          key={alert.id}
          style={{
            background: 'rgba(255,255,255,0.8)',
            border: '1px solid var(--border)',
            borderRadius: '8px',
            padding: '12px 16px',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '12px',
          }}
        >
          <AlertBadge severity={alert.severity} />
          <div style={{ flex: 1 }}>
            <div
              style={{
                fontFamily: 'var(--sans)',
                fontSize: '14px',
                fontWeight: 500,
                color: 'var(--ink)',
              }}
            >
              {alert.title}
            </div>
            {alert.description && (
              <div
                style={{
                  fontFamily: 'var(--sans)',
                  fontSize: '12px',
                  color: 'var(--ink-muted)',
                  marginTop: '4px',
                }}
              >
                {alert.description}
              </div>
            )}
          </div>
          {onResolve && (
            <button
              onClick={() => onResolve(alert.id)}
              style={{
                background: 'none',
                border: '1px solid var(--border)',
                borderRadius: '6px',
                padding: '4px 10px',
                fontSize: '11px',
                fontFamily: 'var(--sans)',
                color: 'var(--ink-muted)',
                cursor: 'pointer',
              }}
            >
              Resolver
            </button>
          )}
        </div>
      ))}
    </div>
  )
}
